import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "initial-menu screen" }
const _hoisted_2 = { class: "menu-content" }
const _hoisted_3 = {
  key: 0,
  class: "menu-actions"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Crear una partida ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Unirse a una partida existente ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Crear partida de prueba ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "#game-id" }, "Escribe el ID de la partida", -1)
const _hoisted_8 = { class: "form-actions" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Cancelar ")
const _hoisted_10 = { type: "submit" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Unirse ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_screen_title = _resolveComponent("screen-title")!
  const _component_Flag = _resolveComponent("Flag")!
  const _component_Anchor = _resolveComponent("Anchor")!
  const _component_Wrench = _resolveComponent("Wrench")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_screen_title),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.joiningGame)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createGame()))
            }, [
              _createVNode(_component_Flag, {
                size: 18,
                "stroke-width": 1.5
              }, null, 8, ["stroke-width"]),
              _hoisted_4
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.joiningGame = true))
            }, [
              _createVNode(_component_Anchor, {
                size: 18,
                "stroke-width": 1.5
              }, null, 8, ["stroke-width"]),
              _hoisted_5
            ]),
            _createElementVNode("button", {
              class: "btn-ghost",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createDebugGame()))
            }, [
              _createVNode(_component_Wrench, {
                size: 16,
                "stroke-width": 1.5
              }, null, 8, ["stroke-width"]),
              _hoisted_6
            ])
          ]))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.joinGame()), ["prevent"]))
          }, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              autofocus: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.joiningGameId) = $event)),
              class: "game-id-input"
            }, null, 512), [
              [_vModelText, _ctx.joiningGameId]
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.joiningGame = false))
              }, [
                _createVNode(_component_ArrowLeft, {
                  size: 16,
                  "stroke-width": 1.5
                }, null, 8, ["stroke-width"]),
                _hoisted_9
              ]),
              _createElementVNode("button", _hoisted_10, [
                _createVNode(_component_Anchor, {
                  size: 16,
                  "stroke-width": 1.5
                }, null, 8, ["stroke-width"]),
                _hoisted_11
              ])
            ])
          ], 32))
    ])
  ]))
}